import React, { Component } from 'react';
import { Input, Dropdown } from 'semantic-ui-react'
import InfiniteScroll from 'react-infinite-scroll-component'
import './easy_table.css';

class EasyTable extends Component {
  constructor(props){
    super(props);
    this.state = {
      noDataMessage: 'No data loaded. Please load or create one',
      defaultStyle: { width: '100%', height: '100%' },
      data: this.props.data,
      sort: this.props.defaultSort,
      row: {},
      column: {},
      oldValue: '',
      newValue: '',
      inputRefs: {}
    }

    this.isChanging = false;

  }

  componentWillReceiveProps = (nextProps) => {
    if(nextProps.data !== this.props.data){
      this.setState({
        data: nextProps.data,
      })
    }

    if(nextProps.column !== this.props.columns){
      var refs = {}
      nextProps.columns.map((column, i)=>{
        if (column.hidden) return;
        refs[`filter_${column.dataField}`] = column.filter ? column.filter.defaultValue : '';
        return true
      })
      this.setState({
        inputRefs: refs
      })
    }

  }

  isFunction = (object) => {
   return typeof(object) === 'function';
  }

  renderEditable = (parentRef, staticRef, editableRef, placeholderRef=null, placeholderContentRef=null) => {
    if (placeholderRef){
      this.refs[placeholderRef].style.display = 'block'
    }
    this.refs[parentRef].style.padding = '0px'
    this.refs[staticRef].style.display = 'none'
    this.refs[editableRef].style.display = 'block'
    this.refs[editableRef].focus()

    
  }

  renderStatic = (parentRef, staticRef, editableRef, placeholderRef=null, placeholderContentRef=null) => {
    if (placeholderRef){
      this.refs[placeholderRef].style.display = 'none'
    }
    this.refs[parentRef].style.padding = '5px'
    this.refs[staticRef].style.display = 'block'
    this.refs[editableRef].style.display = 'none'
  }

  sortBy = (dataField) => {
    if(this.isChanging){
      setTimeout(()=>{
        console.log('Canceling sort while update is in progress.');
      },2000)
      this.isChanging = false
      return
    }
    var sort = this.state.sort
    if(dataField !== sort.sortField){
      sort.sortOrder = 'asc'
    }
    else {
      sort.sortOrder = sort.sortOrder === 'asc' ? 'desc' : 'asc'
    }
    sort.sortField = dataField
    this.setState({
      sort: sort
    })
    this.props.columnEvent('sort', sort)
  }

  onInputChange = (evt, field) => {
    this.state.inputRefs[evt.target.name] = evt.target.value
    this.setState({
      inputRefs: this.state.inputRefs,
      currentInputRef: evt.target.name,
      currentInputValue: evt.target.value
    }, () => {
      var state = {
        filters: {}
      }
      state.filters[field] = {
        filterVal: this.state.currentInputValue
      }
      this.props.columnEvent('filter', state)
    })
  }

  onInputFocus = (evt, field) => {
    const focusedId = evt.target.id;
    const { currentInputRef, currentInputValue } = this.state;
    var refs = Object.getOwnPropertyNames(this.state.inputRefs)
    if(refs.length > 0){
      refs.map((ref)=>{
        if (ref === focusedId) return;

        var element = document.getElementById(ref)
        if (element) element.value = '';
      })
    }

    if (evt.target.name !== currentInputRef && currentInputValue) {
      this.onInputChange(evt, field);
    };
    
  }

  renderColumns = (props) => {
    const { columns, lockedColumnHeadings, translations, readOnly=false } = props
    return (
      <div key='head' className={`easy-table-heading-row ${lockedColumnHeadings ? 'locked' : ''}`}>
        {
          columns.map((column, colIndex)=>{
            if(column.hidden) return;

            let headProps = {
              key: `head-${column.dataField}`,
              className: 'easy-table-heading-cell',
              title: column.text
            }

            if (!readOnly) headProps.onClick = (evt) => this.sortBy(column.dataField);

            if(column.headerStyle){
              headProps.style = column.headerStyle
            }
            if(column.headerClasses){
              headProps.className = `${headProps.className} ${column.headerClasses}`
            }
            var inputRef = `filter_${column.dataField}`
            var filterElement = ''
            if(column.filter){
              filterElement = (
                <Input
                  key={inputRef}
                  ref={inputRef}
                  name={inputRef}
                  id={inputRef}
                  className='easy-table-input'
                  placeholder={`${translations.search} ${column.text}`}
                  defaultValue={this.state.inputRefs[inputRef]}
                  onChange={(evt)=>this.onInputChange(evt, column.dataField)}
                  onClick={(evt)=>evt.stopPropagation()}
                  onFocus={(evt)=>this.onInputFocus(evt, column.dataField)}
                >
                </Input>
              )
            }
            return (
              <div {...headProps}>
                {
                  column.headerFormatter && column.headerFormatter(column, colIndex, { filterElement })
                }
                {
                  !column.headerFormatter && column.text
                }
              </div>
            )
          })
        }
      </div>
    )
  }

  onTextAreaFocus = (evt, row, column) => {
    this.setState({
      oldValue: evt.target.value,
      newValue: evt.target.value,
      row: row,
      column: column
    })
  }

  onTextareaChange = (evt, oldValue, row, column, rowIndex) => {
    this.isChanging = true
    var data = this.state.data
    row[column.dataField] = evt.target.value
    data[rowIndex] = row
    this.setState({
      oldValue: oldValue,
      row: row,
      column: column,
      newValue: evt.target.value,
      data: data,
    })
  }

  onTextareaBlur = (evt, rowIndex) => {
    const { oldValue, newValue, row, column } = this.state
    if (column.validator && !column.validator(newValue)){
      this.resetTextareaValue(evt, rowIndex);
      return;
    }
    this.props.cellEvent(oldValue, newValue, row, column)
  }

  resetTextareaValue = (evt, rowIndex) =>{
    const { oldValue, column } = this.state
    var { newValue, row, data } = this.state
    evt.target.value = oldValue
    newValue = oldValue
    row[column.dataField] = oldValue
    data[rowIndex] = row
    this.setState({ oldValue, newValue, row, column, data })
  }

  onDropdownChange = (evt, obj, oldValue, row, column, rowIndex) => {
    var data = this.state.data
    row[column.dataField] = obj.value
    data[rowIndex] = row
    this.setState({
      oldValue: oldValue,
      row: row,
      column: column,
      newValue: obj.value,
      data: data,
    })
    this.props.cellEvent(oldValue, obj.value, row, column)
  }

  render() {
    const { keyField, columns, showHeading, loader, fetchMore, translations, className, style, customLoadingMessage } = this.props
    const { defaultStyle, data } = this.state
    return (
      <div className={`easy-table ${className}`} style={style ? style : defaultStyle}>
        {
          showHeading &&
          <div className='easy-table-heading'>
          </div>
        }

        <InfiniteScroll
          dataLength={data.length}
          next={fetchMore}
          hasMore={true}
          loader={loader}
          height={1}
        >
          <div className='easy-table-body'>
            {
              this.renderColumns(this.props)
            }
            {
              data && data.length > 0 &&
              data.map((row, rowIndex)=>{
                return (
                  <div key={row[keyField]} className={`easy-table-data-row`}>
                    {
                      columns.map((column, colIndex)=>{
                        if(column.hidden) return

                        var parentRef = `${rowIndex}${colIndex}`
                        var dataProps = {
                          key: `data-${column.dataField}`,
                          className: 'easy-table-data-cell',
                          ref: parentRef
                        }
                        if(column.headerStyle){
                          dataProps.style = column.headerStyle
                        }
                        if(column.cellStyle){
                          dataProps.style = column.cellStyle
                        }
                        if(column.classes){
                          var dataClass = this.isFunction(column.classes) ? column.classes(row[column.dataField], row, rowIndex, colIndex) : column.classes
                          dataProps.className = `${dataProps.className} ${dataClass}`
                        }
                        var staticRef = `static-${rowIndex}${column.dataField}`
                        var editableRef = `editable-${rowIndex}${column.dataField}`
                        var editable = this.isFunction(column.editable) ? column.editable(row[column.dataField], row, rowIndex, colIndex, column) : column.editable
                        if(editable){
                          dataProps.onClick = (evt) => this.renderEditable(parentRef, staticRef, editableRef)
                          dataProps.onBlur = (evt) => this.renderStatic(parentRef, staticRef, editableRef)
                          dataProps.className = `${dataProps.className} editable`
                        }
                        var isDropdown = column.editor ? column.editor.type === 'dropdown' : false
                        if(isDropdown && column.editable){
                          dataProps.onMouseOver = (evt) => this.renderEditable(parentRef, staticRef, editableRef)
                          dataProps.onMouseOut = (evt) => this.renderStatic(parentRef, staticRef, editableRef)
                        }
                        var isModal = column.editor ? column.editor.type === 'modal' : false
                        if(isModal && column.editable){
                          dataProps.onClick = (evt) => column.events.onClick(evt, row[column.dataField], row, column, rowIndex, colIndex)
                          dataProps.className = `${dataProps.className} clickable`
                        }
                        if(column.events && column.editable){
                          if(column.events.onContextMenu){
                            dataProps.onContextMenu = (evt) => column.events.onContextMenu(evt, row[column.dataField], rowIndex)
                            dataProps.onMouseDown = (evt) => column.events.onMouseDown(evt)
                          }
                        }
                        var placeholder = column.editor && column.editor.placeholder ? column.editor.placeholder : "";
                        return (
                          <div {...dataProps}>
                            {
                              !isDropdown && column.formatter &&
                              <div style={column.cellInnerDivStyle} ref={staticRef}>{column.formatter(row[column.dataField], row, rowIndex, column)}</div>
                            }
                            {
                              !isDropdown && !column.formatter &&
                              <div ref={staticRef}>{row[column.dataField]}</div>
                            }
                            {
                              editable &&
                              <textarea
                                ref={editableRef}
                                className='easy-table-textarea'
                                defaultValue={row[column.dataField]}
                                onChange={(evt)=>this.onTextareaChange(evt, this.state.oldValue, row, column, rowIndex)}
                                onBlur={(evt)=>this.onTextareaBlur(evt, rowIndex)}
                                onFocus={(evt)=>this.onTextAreaFocus(evt, row, column)}
                                onContextMenu={(evt)=>evt.stopPropagation()}
                                placeholder={placeholder}
                              >
                              </textarea>
                            }
                            {
                              isDropdown && column.formatter &&
                              <div ref={staticRef}>{column.formatter(row[column.dataField], row, rowIndex, column)}</div>
                            }
                            {
                              isDropdown &&
                              <div
                                ref={editableRef}
                                className='easy-table-dropdown'
                              >
                                <Dropdown
                                  fluid
                                  selection
                                  floating
                                  options={ column.editor.options }
                                  value={ row[column.dataField] }
                                  onChange={(evt, obj)=>this.onDropdownChange(evt, obj, row[column.dataField], row, column, rowIndex)}
                                  forceSelection={false}
                                  selectOnBlur={false}
                                />
                              </div>

                            }
                          </div>
                        )
                      })
                    }
                  </div>
                )
              })
            }
            {
              !data || data.length === 0 &&
              <div className='easy-table-no-data'>{translations && translations.no_data}</div>
            }
          </div>
          {
            customLoadingMessage
            ?
            customLoadingMessage
            :
            <div id="loading-message">
              <i className="loading circle notched icon plan-loading"></i>
              <span>{translations && translations.fetching_activities}</span>
            </div>
          }
        </InfiniteScroll>
      </div>
    )
  }
}



export default EasyTable;



// WEBPACK FOOTER //
// ./src/components/easy_table.js